import React from 'react';
import cx from 'classnames';
import { Trans } from '@elevio/kb-kit/lib/components/trans';
import LoginLogout from './LoginLogout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
const CONTACT_US = 'https://www.deerfield.il.us/142/Contact';
const YOUTUBE = 'https://www.deerfield.il.us/youtube';
const FACEBOOK = 'https://www.deerfield.il.us/facebook';
function Footer({ className }) {
    return (<footer className={cx('footer', className)} data-testid="footer">
      <div className="footer-wrapper">
        <p className="footer-copyright">
          &copy; {new Date().getFullYear()} Comcate, Inc.
        </p>
        <nav className="footer-nav">
          <a className="footer-link" target="_blank" href={CONTACT_US}>
            <Trans>Contact Us</Trans>
          </a>
          <a className="footer-link" target="_blank" href={YOUTUBE} aria-label="YouTube">
            <FontAwesomeIcon icon={faYoutube} aria-hidden="true"/>
          </a>
          <a className="footer-link" target="_blank" href={FACEBOOK} aria-label="Facebook">
            <FontAwesomeIcon icon={faFacebookF} aria-hidden="true"/>
          </a>
          <LoginLogout className="footer-link"/>
        </nav>
      </div>
    </footer>);
}
export default Footer;
